import React from 'react';
import { Box, IconButton } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { BRAND_LUXE_SECONDARY } from './brandDashboardTokens';

/** First row count when using a 2-column grid (2×2). */
export const BRAND_CARD_GRID_INITIAL_COUNT = 4;

const lineLeft =
    'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.06) 35%, rgba(255,255,255,0.32) 100%)';
const lineRight =
    'linear-gradient(270deg, transparent 0%, rgba(255,255,255,0.06) 35%, rgba(255,255,255,0.32) 100%)';

export interface BrandExpandCardsDividerProps {
    expanded: boolean;
    onToggle: () => void;
    /** e.g. "campaigns" / "auditions" for aria-label */
    sectionLabel: string;
}

/**
 * Horizontal fade lines with a centered chevron — expands/collapses extra cards below the first grid row pair.
 */
export function BrandExpandCardsDivider({ expanded, onToggle, sectionLabel }: BrandExpandCardsDividerProps) {
    return (
        <Box
            role="separator"
            sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                gap: 1.25,
                py: { xs: 1.5, sm: 2 },
            }}>
            <Box sx={{ flex: 1, height: '1px', background: lineLeft }} />
            <IconButton
                type="button"
                onClick={onToggle}
                aria-expanded={expanded}
                aria-label={expanded ? `Show fewer ${sectionLabel}` : `Show more ${sectionLabel}`}
                disableRipple={false}
                sx={{
                    color: 'rgba(255,255,255,0.75)',
                    p: 0.75,
                    '&:hover': {
                        color: BRAND_LUXE_SECONDARY,
                        bgcolor: 'rgba(255,255,255,0.06)',
                    },
                }}>
                <KeyboardArrowDownIcon
                    sx={{
                        fontSize: 26,
                        transition: 'transform 0.22s ease',
                        transform: expanded ? 'rotate(-180deg)' : 'rotate(0deg)',
                    }}
                />
            </IconButton>
            <Box sx={{ flex: 1, height: '1px', background: lineRight }} />
        </Box>
    );
}
